/*
 * Service for updating visitor info and submitting verification data for user profile.
 *
 * Responsibilities:
 * - Patch visitor profile info using operations payload.
 * - Submit verification data for user profile verification.
 */
import type { ApiClient } from "@/common/api/http/types";

interface IUpdateParams {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

export default class VisitorService {
  public constructor(private readonly client: ApiClient) {}

  async updateVisitorInfo(params: IUpdateParams[]) {
    return await this.client.patch("v1/me", { operations: params });
  }

  async verifyUserProfile(verifyData: { [key: string]: string }) {
    return await this.client.post("v2/me/verify-profile", verifyData);
  }
}
